<template>
  <div class="top-navbar">
    <base-nav
      container-classes="container-fluid"
      class="navbar-top navbar-expand"
      :class="{ 'navbar-dark': type === 'default' }"
    >
      <!-- <a
        href="#"
        aria-current="page"
        class="
          h4
          mb-0
          text-black text-uppercase
          d-none d-lg-inline-block
          active
          router-link-active
        "
      >
        <p class="page-title">
          {{ $route.meta.title }}
        </p>
      </a> -->

      <!-- Navbar links -->
      <b-navbar-nav class="align-items-center ml-lg-auto">
        <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
        <li class="nav-item d-sm-none">
          <a
            class="nav-link"
            href="#"
            data-action="search-show"
            data-target="#navbar-search-main"
          >
            <i class="ni ni-zoom-split-in"></i>
          </a>
        </li>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto ml-lg-0">
        <div>
          <b-dropdown
            class="user-info-box"
            size="lg"
            menu-class="w-100"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <b-icon
                icon="person"
                class="icon-mdi-account-outline-copy"
              ></b-icon>
              <span class="account-name">{{ user.name }}</span>
              <!-- <b-icon :icon="userBoxArrow" class="bi-chevron-down"></b-icon> -->
            </template>
          </b-dropdown>
        </div>

        <div class="icon-container">
          <b-icon icon="house-door" class="icon"></b-icon>
        </div>
        <div class="icon-container mr-3">
          <!-- <b-badge class="notification-count" href="#" variant="primary">{{
            notificationCount
          }}</b-badge> -->
          <b-icon v-b-toggle.sidebar-backdrop icon="bell" class="icon"></b-icon>
        </div>
        <div @click="logout()" class="icon-container mr-3">
          <!-- <b-badge class="notification-count" href="#" variant="primary">{{
            notificationCount
          }}</b-badge> -->
          <b-icon
            v-b-toggle.sidebar-backdrop
            icon="power"
            class="icon"
          ></b-icon>
        </div>
      </b-navbar-nav>
    </base-nav>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import CurtainMenu from "@/components/CurtainMenuPlugin/CurtainMenu.vue";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    CurtainMenu,
  },

  props: {
    type: {
      type: String,
      default: "light", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },

    user: {
      type: Object,
      description:
        "Whether navbar menu is shown (valid for viewports < specified by `expand` prop)",
    },
  },

  data() {
    return {
      userBoxArrow: "chevron-down",
      notificationCount: 22,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
    };
  },

  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },

  mounted() {
    this.toggle_icon();
  },

  methods: {
    toggle_icon() {
      this.$root.$on("bv::dropdown::show", (bvEvent) => {
        this.userBoxArrow = "chevron-up";
      });
      this.$root.$on("bv::dropdown::hide", (bvEvent) => {
        this.userBoxArrow = "chevron-down";
      });
    },

    logout() {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push("/login");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },

    closeDropDown() {
      this.activeNotifications = false;
    },
  },
};
</script>

<style>
.main-content .navbar-top {
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16) !important;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16) !important;
}
</style>
